import { ro } from "./translations/ro";

function hasValue(value) {
	return value !== null && value !== undefined && String(value).trim() !== "";
}

function utilityLabel(type) {
	if (!hasValue(type)) return "";
	return ro.types[type] || String(type);
}

function formatEntry(payment) {
	if (!payment) return "";
	const label = utilityLabel(payment.type);
	if (!label) return "";
	if (!hasValue(payment.amount)) return label;
	const amount = String(payment.amount).trim();
	if (!hasValue(payment.currency)) return `${label} - ${amount}`;
	return `${label} - ${amount} ${String(payment.currency).trim()}`;
}

export function buildDispositionDescription(payments) {
	if (!Array.isArray(payments)) return "";
	return payments.map(formatEntry).filter(Boolean).join(", ");
}
